import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import * as moment from 'moment';

@Component({
  selector: 'app-carrello-items',
  templateUrl: './carrello-items.component.html',
  styleUrls: ['./carrello-items.component.css']
})
export class CarrelloItemsComponent implements OnChanges {

  getTotaleBusTour(tour) {
    const costoExtra = parseFloat(tour.costoExtra);
    const adulti = parseInt(tour.adulti, 10);
    const minori = parseInt(tour.minori, 10);
    return costoExtra * (adulti + minori);
  }

  getTotaleVisita(tour, visita) {
    const przVisita = parseFloat(visita.costo);
    const adulti = tour.adulti;
    return (przVisita * adulti);
  }

  getTotaleBuonoCantina(buonoCantina) {
    let prz = parseFloat(buonoCantina.totale);
    if (buonoCantina.pacchetti != null) {
      prz += parseFloat(buonoCantina.pacchetti[0]['costoFinale']);
    }
    return prz;
  }

  getTotaleBuono(buono) {
    let prz = parseFloat(buono.valore);
    if (buono.pacchetti != null) {
      prz += parseFloat(buono.pacchetti[0]['costoFinale']);
    }
    return prz;
  }

  getTotalePacchetti(pacchetto) {
    let prz = 0;
    if (pacchetto.pacchetti != null) {
      prz += parseFloat(pacchetto.pacchetti[0]['costoFinale']);
    }
    return prz;
  }

  getTotaleVini(riga) {
    let totale = 0;
    totale += parseFloat(riga.totaleVino);
    totale += parseFloat(riga.costoSpedizioneCliente);
    totale += this.getTotaleBuoniVini(riga);
    totale += riga.sconto;

    const idCantina = riga.idCantina;
    const codici_per_cantina = this.listaCodiciScontoCarrello.filter(codice => codice.idCantina === idCantina).length > 0 ?
      this.listaCodiciScontoCarrello.filter(codice => codice.idCantina === idCantina) : null;

    riga.sconto_codici = [];
    let i = 0;
    if (codici_per_cantina && codici_per_cantina.length > 0) {
      for (const codice of codici_per_cantina) {
        if (codice.tipo_codice === '1') {
          if (parseInt(codice.minimo_bottiglie, 10) <= parseInt(riga.qta_abilitati, 10)) {
            if (codice.tipo_unita_codice === '0') {
              totale += (codice.valore * -1);
            } else {
              totale += ((parseFloat(riga.totale_abilitati) + riga.sconto) / 100 * codice.valore) * -1;
            }
            riga.sconto_codici[i] = codice;
          }
        } else {
          if (parseFloat(codice.minimo_totale) <= parseFloat(riga.totale_abilitati)) {
            if (codice.tipo_unita_codice === '0') {
              totale += (codice.valore * -1);
            } else {
              totale += ((parseFloat(riga.totale_abilitati) + riga.sconto) / 100 * codice.valore) * -1;
            }
            riga.sconto_codici[i] = codice;
          }
        }
        i++;
      }
    }

    return totale;
  }

  getTotaleViniBottiglie(riga) {
    let prz = 0;
    prz += parseFloat(riga.totaleVino);
    return prz;
  }

  getTotaleViniBottiglieAbilitateSconto(riga) {
    let prz = 0;
    prz += parseFloat(riga.totale_abilitati);
    return prz;
  }

  chooseScontoVini(riga) {
    if (riga.attivoScontoPerc) {
      return parseFloat(riga.scontoPercentuale);
    } else {
      return parseFloat(riga.scontoEuro);
    }
  }

  chooseValutaScontoVini(riga) {
    if (riga.attivoScontoPerc) {
      return '%';
    } else {
      return '€';
    }
  }

  getMinimoScontoVini(riga) {
    return riga.scontoFrom - this.getTotaleViniBottiglieAbilitateSconto(riga);
  }

  getTotaleBuoniVini(riga) {
    let prz = 0;
    for (const vino of riga.vini) {
      for (const buono of vino.buoni) {
        prz += parseFloat(buono.totale);
      }
    }
    return prz;
  }

  viniHaveBuoni(riga) {
    let prz = 0;
    for (const vino of riga.vini) {
      prz += vino.buoni.length;
    }
    return prz > 0 ? true : false;
  }

  @Input() carrello: any;
  @Input() buoniCantina: any;
  @Input() carrelloVini: any;
  @Input() carrelloPacchetti: any;
  @Input() formCarrello: any;
  @Input() controllaCantinaSC: boolean
  @Input() listaCodiciScontoCarrello: Array<any>;

  @Output() rimuoviDalCarrelloBuoniCantinaEmit = new EventEmitter<any>();
  @Output() rimuoviDalCarrelloEmit = new EventEmitter<any>();
  @Output() rimuoviDalCarrelloSCEmit = new EventEmitter<any>();
  @Output() rimuoviDalCarrelloViniEmit = new EventEmitter<any>();
  @Output() rimuoviDalCarrelloPacchettiEmit = new EventEmitter<any>();
  @Output() rimuoviDalCarrelloVinoSingoloEmit = new EventEmitter<any>();
  @Output() rimuoviCodiceScontoVinoEmit = new EventEmitter<any>();

  constructor(
    private adapter: DateAdapter<any>,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnInit(): void {
    this.adapter.setLocale('it');
  }

  rimuoviDalCarrelloBuoniCantina(id) {
    this.rimuoviDalCarrelloBuoniCantinaEmit.emit(id);
  }

  rimuoviDalCarrello(id) {
    this.rimuoviDalCarrelloEmit.emit(id);
  }

  rimuoviDalCarrelloSC(id) {
    this.rimuoviDalCarrelloSCEmit.emit(id);
  }

  rimuoviDalCarrelloVini(id) {
    this.rimuoviDalCarrelloViniEmit.emit(id);
  }

  rimuoviDalCarrelloVinoSingolo(id) {
    this.rimuoviDalCarrelloVinoSingoloEmit.emit(id);
  }

  rimuoviDalCarrelloPacchetti(id) {
    this.rimuoviDalCarrelloPacchettiEmit.emit(id);
  }

  rimuoviCodiceScontoVino(codice) {
    this.rimuoviCodiceScontoVinoEmit.emit(codice);
  }

  mostraCancella(idx) {

    const nDaControllare = this.carrello[idx].collegate;

    if (nDaControllare === null) {
      return true;
    } else {
      let index1 = -1;
      let index2 = -1;
      for (let i = 0; i < this.carrello.length; i++) {
        const nfor = this.carrello[i].collegate;
        if (nfor === null || nfor !== nDaControllare) {
        } else {
          if (index1 === -1) {
            index1 = i;
          } else {
            index2 = i;
          }
        }
      }
      if (idx === index1) {
        return true;
      } else {
        return false;
      }
    }
  }

  totaleRiga(riga): number {
    let totRiga = parseFloat(riga.totale);
    if (riga.checksupplemento === '1' && this.formCarrello.value.tipoPagamento === "CANTINASC") {
      totRiga += (parseFloat(riga.supplemento) * riga.nadulti)
    }
    return totRiga;
  }

  checkSC(prenotazione: any) {
    let ok = false;
    if (this.controllaCantinaSC && prenotazione.checksupplemento === '1' && this.formCarrello.value.tipoPagamento === "CANTINASC") {
      ok = true;
    }
    return ok;
  }

  getDataScadenzaBuono(buono) {
    if (buono.tiporegala === 'gg') {
      const duratagg = parseInt(buono.durata, 10);
      return moment().add(duratagg, 'days').format('DD-MM-YYYY');
    } else if (buono.tiporegala === 'data') {
      return buono.fineregala;
    }
  }

  getSupplementoTotale(prenotazione) {
    return (parseInt(prenotazione.nadulti, 10) + parseInt(prenotazione.nadulti_solovisita, 10)) * prenotazione.supplemento
  }

  visitaHasPernottamento(acquisto) {
    return acquisto.tipo.includes('P');
  }

  getDataSvolgimento(acquisto) {
    let data = {};
    data['translation'] = false;
    data['data'] = '';

    if (acquisto.svolgimento_esperienza_visita === '1') {
      data['translation'] = false;
      data['data'] = moment(acquisto.dataora).add(1, 'days');
    } else {
      if (acquisto.svolgimento_esperienza_visita === '0') {
        data['translation'] = true;
        data['data'] = 'prenotazioni.stessadata';
      } else {
        data['data'] = 'prenotazioni.datasceltaopzione';
        data['translation'] = true;
      }
    }
    return data;
  }

  msgAttenzione(rigaVino) {

    let obj: any;
    let totaleBottiglie: number = rigaVino.totale_abilitati;

    let msg = '';
    let title = '';
    let values: any;
    let ko = false;
    let color = '';

    if (rigaVino.attivoVoucherCarrello) {
      if (rigaVino.attivoScontoFromVoucher) {
        values = {
          value0: (parseFloat(rigaVino.scontoFromVoucher) - totaleBottiglie).toFixed(2)
        }
        ko = totaleBottiglie >= parseFloat(rigaVino.scontoFromVoucher) ? false : true;
        title = ko ? 'carrello__item.omaggioFromKO_title' : 'carrello__item.omaggioOK_title';
        msg = ko ? 'carrello__item.omaggioFromKO_content' : 'carrello__item.omaggioOK';
        color = !ko ? 'PRIMARY' : 'PRIMARY';
      } else {
        values = {
          value0: parseInt(rigaVino.pezziMin, 10) - parseInt(rigaVino.qta_abilitati, 10)
        }
        ko = rigaVino.qta_abilitati >= rigaVino.pezziMin ? false : true;
        title = ko ? 'carrello__item.omaggioPezziKO_title' : 'carrello__item.omaggioOK_title';
        msg = ko ? 'carrello__item.omaggioPezziKO_content' : 'carrello__item.omaggioOK';
        color = !ko ? 'PRIMARY' : 'PRIMARY';
      }

      obj = {
        title: title,
        msg: msg,
        values: values,
        ko: ko,
        color: color
      }

    } else {
      obj = {
        title: null,
        msg: null,
        values: [],
        visible: false
      }
    }

    return obj
  }

  msgSconto(riga) {
    let obj = {
      title: 'carrello__item.sconto_title',
      content: '',
      values: {
        mancanti: this.getMinimoScontoVini(riga).toFixed(2),
        sconto: this.chooseScontoVini(riga).toFixed(2)
      }
    };
    if (riga.attivoScontoPerc) {
      obj.content = 'carrello__item.scontoperc';
    } else {
      obj.content = 'carrello__item.scontoeuro';
    }

    return obj;
  }

  pezziMinViniOk(riga) {
    let result = true;
    if (parseInt(riga.pezziMin, 10) > parseInt(riga.qta, 10)) {
      return false;
    }
    return result;
  }

  isMultipliVinoOK(riga) {
    return parseInt(riga.qta, 10) % parseInt(riga.multipli, 10) === 0 ? true : false
  }

  isMinimiVinoOk(riga) {
    return parseInt(riga.qta, 10) >= parseInt(riga.pezziMin, 10) ? true : false;
  }

  getExMultipli(multiplo) {
    let string = '(';
    string += parseInt(multiplo, 10) * 1;
    string += ' ' + parseInt(multiplo, 10) * 2;
    string += ' ' + parseInt(multiplo, 10) * 3;
    string += '...)';

    return string;
  }
}
